import axios from 'axios'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

const useCurrency = () => {
  const [currency, setCurrency] = useState([])
  const company = useSelector((state) => state.company.company)

  const company_tax_id = useMemo(() => company?.taxId, [company])
  const pin = useMemo(() => company?.pin, [company])
  const ERP_API = useMemo(() => company?.ip, [company])

  const formData = useMemo(
    () => ({
      taxId: company_tax_id,
      pin,
      ip: ERP_API,
    }),
    [company_tax_id, pin, ERP_API],
  )

  useEffect(() => {
    const getCurrency = async (formData) => {
      if (!company_tax_id) return
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_IP}/protocol/erp-currency`, {
          formData,
        })

        const parsed = response.data

        setCurrency(Array.isArray(parsed) ? parsed : [])
      } catch (error) {
        toast.error(error.message || 'Failed to fetch currency')
        setCurrency([])
      }
    }

    if (formData) getCurrency(formData)
  }, [formData])

  return currency
}

export default useCurrency
